import React from "react";
import TitleDescriptionForm from "./TitleForm";
import FlagsForm from "./FlagsForm";
import StoreSlug from "./StoreSlug";
import TitleDescription from "./TitleDescription";
import CodeList from "./CodeList";
import Flags from "./Flags";
import CodesForm from "./CodesForm";

export default function getColumns(categories, specials, couponKinds) {
  return [
    {
      field: "store",
      headerName: "Loja e Slug",
      flex: 0.7,
      editable: false,
    },
    {
      field: "title",
      headerName: "Título e Descrição",
      flex: 1.7,
      editable: true,
    },
    {
      field: "description",
      editable: true,
      sortable: false,
    },
    {
      field: "codes",
      headerName: "Códigos",
      flex: 0.5,
      editable: true,
    },
    {
      field: "kind",
      headerName: "Tipo de cupom",
      flex: 0.5,
      editable: true,
      type: "singleSelect",
      valueOptions: couponKinds,
    },
    {
      field: "category",
      headerName: "Categoria Principal",
      flex: 0.5,
      editable: true,
      type: "singleSelect",
      valueOptions: categories,
    },
    {
      field: "specials",
      headerName: "Especiais",
      flex: 0.5,
      editable: true,
      type: "singleSelect",
      valueOptions: specials,
    },

    {
      field: "exclusive",
      headerName: "Flags",
      flex: 0.4,
      editable: true,
    },
    {
      field: "disabled",
      type: "boolean",
      editable: true,
      sortable: false,
    },
    {
      field: "show_at_home",
      type: "boolean",
      editable: true,
      sortable: false,
    },
    {
      field: "track_url",
      type: "boolean",
      editable: true,
      sortable: false,
    },
  ];
}
